export default class PaginationDTO {
  constructor(item = {}) {
    this.size = item.size || item.page_size
    this.page = item.page
    this.count = item.count
    this.next = item.next
    this.previous = item.previous
  }
}